<h2 mat-dialog-title>Physical texture size</h2>
<mat-dialog-content>
    <form id="textureForm" (submit)="confirmAction()">
        <cm-linked-dimension-input
            [(width)]="$width"
            [(height)]="$height"
            [forcedAspectMode]="true"
            [aspectRatio]="resolutionAspectRatio"
            [widthPlaceholder]="!$isImperial() ? 'Width (cm)' : 'Width (in)'"
            [heightPlaceholder]="!$isImperial() ? 'Height (cm)' : 'Height (in)'"
        />
        @if ($showDisplacementSetting()) {
            <cm-numeric-field [(value)]="$displacement" label="Displacement" [placeholder]="!$isImperial() ? 'Displacement (cm)' : 'Displacement (in)'" />
        }
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="cancelAction()">Cancel</button>
    <button mat-button form="textureForm" [disabled]="!$isValidData()">Ok</button>
</mat-dialog-actions>
